import { render, staticRenderFns } from "./edit-social-security-data.vue?vue&type=template&id=779d78d5"
import script from "./edit-social-security-data.vue?vue&type=script&lang=ts"
export * from "./edit-social-security-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports